import { SimNaoEnum } from 'components/form'

import {
  isAllFilled,
  isPerguntaOutroFilled,
  isPerguntaOutroSelected,
  isPerguntaOutroSim,
} from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta15Model,
  ConsultaSeguimentoPergunta15TentaImitarEnum,
} from './model-consultaSeguimentoPergunta15'

const consultaSeguimentoPergunta15TentaImitarEnumValues = Object.values(ConsultaSeguimentoPergunta15TentaImitarEnum)

export function isPergunta15TentaImitarAllFilled(value: ConsultaSeguimentoPergunta15Model): boolean {
  const isExemplosAllFilled = isAllFilled(
    value?.PERGUNTA_15_TENTA_IMITAR,
    consultaSeguimentoPergunta15TentaImitarEnumValues
  )

  if (isPerguntaOutroFilled(value?.OUTRO)) {
    return isExemplosAllFilled && isPerguntaOutroSelected(value?.OUTRO)
  }

  return isExemplosAllFilled
}

export function hasPergunta15TentaImitarAtLeastTwoSim(value: ConsultaSeguimentoPergunta15Model): boolean {
  const exemplosMarkedAsSim = Object.values(value?.PERGUNTA_15_TENTA_IMITAR ?? {}).filter(
    (item) => item === SimNaoEnum.SIM
  )

  if (isPerguntaOutroSim(value?.OUTRO)) {
    return exemplosMarkedAsSim.length >= 1
  }

  return exemplosMarkedAsSim.length >= 2
}
